<template>
  <div class="full-screen" style="z-index: 8;">
    <top id="top-nav" :title="bookTitle" :key="`${bookTitle}-catalog`"></top>
    <div class="main" style="height: calc(100% - 2rem); overflow: auto; padding-top: 2rem;">
      <div class="">
        <button class="btn-px" @click="ascending"><strong> {{ tx }}</strong></button>
        <ul class="chapterlist">
          <li v-for="(item, index) in catalog" :key="index">
            <a class="flex" @click="toChapter(item.bookId, item.number)">
              <div class="left">
                <img :bookid="item.bookId" :booktitle="bookTitle" :chapternum="item.number" :imgpath="item.cover" :zoom="1000" v-lazy="require('../../../assets/images/loading.jpeg')"/>
              </div>
              <div class="right">
                <div class="clearfix">
                  <span class="fl">{{item.title}}</span>
                  <span class="fr">
									<span :class="getPriceTextClass(item)">{{getPriceText(item.price, item.alreadyBuy)}}</span>
								</span>
                </div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import bookService from "../../../services/bookService";
  import BookTop from '@/components/layer2/book/book-top'

  export default {
    name: "catagory",
    data() {
      return {
        catalog: [],
        bookTitle: '',
        ascend: true,
        tx:'🔻 降序排序'
      }
    },
    methods: {
      ascending(){
        this.ascend = !this.ascend
        if(this.ascend){
          this.tx = '🔻 降序'
          this.catalog.reverse();
        }else{
          this.tx = '🔺 升序'
          this.catalog.reverse();
        }
      },
      getCatalog() {
        bookService.getChapters(this.$route.params.id)
          .then(res => {
            this.catalog = res.data;
          })
      },
      getPriceText(price, alreadyBuy) {
        if (alreadyBuy) {
          return '已购买'
        }
        if (price === 0 || price === '0') {
          return '免费'
        } else {
          return `${price} 金币`
        }
      },
      getPriceTextClass(item) {
        if (item.alreadyBuy){
          return "c3";
        }
        if (item.price == 0){
          return "c1";
        }else {
          return "c2";
        }
      },
      toChapter(bookId, number) {
        this.$router.isBack = false;
        this.$router.push({path: `/book/read/${bookId}/${number}`, query: {title: this.$route.query.title, title2: this.catalog.find(item => item.number === number).title}});
      }
    },
    components: {
      top: BookTop
    },
    mounted() {
      this.getCatalog();
      this.bookTitle = this.$route.query.title;
      this.$router.isBack = true;
    }
  }
</script>

<style scoped>
  * {
    z-index: 8;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layer2/book/catalog.vue